export const mastheadNav = [
  { label: "首页", href: "#top" },
  { label: "今日热点", href: "#today" },
  { label: "热度榜", href: "#ranking" },
  { label: "话题墙", href: "#topics" },
  { label: "实时动态", href: "#live" },
];

export const heroFeature = {
  kicker: "本期封面",
  title: "从一条新增开始，读懂今天讨论的重心",
  summary:
    "黑料总站把站内新增内容、热门事件与话题标签收拢在同一页里。这一版我们刻意放慢了节奏，用更少的模块、更清楚的层级，让你先把今天真正值得看的部分读完，再决定要不要继续往下翻。",
  tags: ["今日热点", "实时更新", "话题聚合"],
  author: "总站编辑部",
  date: "2026.09.11",
  readingTime: "6 分钟",
  stats: [
    { label: "今日新增", value: "128" },
    { label: "热议话题", value: "42" },
    { label: "更新间隔", value: "3 分" },
  ],
};

export const todayBriefs = [
  {
    index: "01",
    tag: "剧集",
    time: "08:40",
    title: "新剧开播首日的讨论方向，比预想中更集中",
    summary: "开播四小时内，站内话题从造型讨论逐步转向剧情节奏，热度曲线一路走高。",
  },
  {
    index: "02",
    tag: "综艺",
    time: "09:15",
    title: "一档老牌综艺的剪辑顺序，成了今天的讨论起点",
    summary: "节目调整叙事顺序后，弹幕与话题区的关注点明显前移，出现了新的解读角度。",
  },
  {
    index: "03",
    tag: "现场",
    time: "10:02",
    title: "音乐节阵容公布，票务话题同步升温",
    summary: "阵容页更新后，站内关于行程与场次的检索量在半小时内翻了一倍。",
  },
  {
    index: "04",
    tag: "社交",
    time: "10:47",
    title: "一条深夜动态带来的连锁反应",
    summary: "从配图细节到发布时间，网友的观察层层递进，话题墙新增了多个分支标签。",
  },
];

export const heatRanking = [
  { rank: 1, title: "年度剧集口碑的二次反转", category: "剧集", heat: 96, trend: "up", delta: "+18%" },
  { rank: 2, title: "综艺剪辑顺序引发的解读潮", category: "综艺", heat: 91, trend: "up", delta: "+12%" },
  { rank: 3, title: "跨界合作官宣后的第一波反应", category: "合作", heat: 87, trend: "new", delta: "新上榜" },
  { rank: 4, title: "音乐节阵容与行程安排的讨论", category: "现场", heat: 78, trend: "up", delta: "+6%" },
  { rank: 5, title: "红毯造型盘点与风格对比", category: "时尚", heat: 71, trend: "down", delta: "-4%" },
  { rank: 6, title: "新剧杀青路透的细节考据", category: "路透", heat: 64, trend: "down", delta: "-7%" },
];

export const topicWall = [
  { name: "今日热点", count: "2.4 万条" },
  { name: "剧集动态", count: "1.8 万条" },
  { name: "综艺现场", count: "1.2 万条" },
  { name: "音乐节", count: "9,640 条" },
  { name: "红毯造型", count: "8,120 条" },
  { name: "官宣合作", count: "7,505 条" },
  { name: "深夜动态", count: "6,318 条" },
  { name: "路透现场", count: "5,204 条" },
  { name: "口碑反转", count: "4,876 条" },
  { name: "话题墙", count: "4,102 条" },
  { name: "站内更新", count: "3,655 条" },
  { name: "编辑视角", count: "2,940 条" },
];

export const liveUpdates = [
  { time: "11:02", tag: "更新", title: "热度榜第 2 位名次上升，关联关键词同步调整" },
  { time: "10:38", tag: "新增", title: "话题墙新增「红毯造型」分支，讨论量持续累积" },
  { time: "10:05", tag: "动态", title: "站内补充三组现场图，编辑完成首轮整理" },
  { time: "09:22", tag: "更新", title: "今日提要第 3 条内容修订，补充时间线信息" },
  { time: "08:50", tag: "新增", title: "新消息进入实时流，热门事件检索量短时上扬" },
  { time: "08:10", tag: "动态", title: "今日热点分区完成换稿，本期封面同步上线" },
];

export const editorPicks = [
  {
    title: "当讨论开始变慢：一期内容的取舍",
    summary: "模块越少，越需要每个位置都站得住。这次我们把版面留给了更能沉淀的内容。",
    author: "总站编辑部",
  },
  {
    title: "从标签到话题，热点是怎么被聚拢的",
    summary: "一个词条如何长成一面话题墙？我们把新增、归并与排序的过程完整摊开来看。",
    author: "话题组",
  },
  {
    title: "更新频率背后的排版逻辑",
    summary: "三分钟一次的同步，并不等于三分钟一次的改版。频率与秩序之间的平衡在这里。",
    author: "版式组",
  },
];

export const footerColumns = [
  {
    title: "栏目",
    links: ["今日热点", "热度榜", "话题墙", "实时动态", "编辑精选"],
  },
  {
    title: "话题",
    links: ["剧集动态", "综艺现场", "音乐节", "红毯造型", "站内更新"],
  },
  {
    title: "关于",
    links: ["关于总站", "更新说明", "编辑准则", "内容纠错", "联系我们"],
  },
];